module.exports = __webpack_public_path__ + "img/navLogo.b61c0623.png";